import React from 'react'
import { Helmet } from 'react-helmet-async'
import CHero from '../Components/contact/CHero'

import GlobalPresence from '../Components/contact/GlobalPresence'
import GeneralEnquiries from '../Components/contact/GeneralEnquiries'

import ContactSection3 from '../Components/home/ContactSection3'

function ContactDummy() {
    return (
        <div>

            <Helmet>
                <title>
                    Contact Mobikode | Technology & Enterprise AI & ServiceNow Consulting Solutions
                </title>

                <meta
                    name="description"
                    content="Get in touch with Mobikode for technology consulting, Enterprise AI & ServiceNow Consulting, AI and automation, cloud engineering, software development, ServiceNow, data analytics, and enterprise technology solutions."
                />

                <meta
                    name="keywords"
                    content="Contact Mobikode, Contact Us Mobikode, Mobikode Contact, Technology Consulting, IT Consulting Services, Enterprise AI & ServiceNow Consulting Services, Software Development Services, AI Automation Services, Cloud Engineering Services, ServiceNow Consulting, Data Analytics Services, Enterprise Technology Solutions, Technology Solutions Company"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/contact"
                />

                <meta
                    property="og:title"
                    content="Contact Mobikode | Technology & Enterprise AI & ServiceNow Consulting Solutions"
                />

                <meta
                    property="og:description"
                    content="Connect with Mobikode to discuss your technology and Enterprise AI & ServiceNow Consulting needs. Explore solutions across AI, cloud, software engineering, ServiceNow, analytics, and enterprise technology."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/contact"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/contact/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Contact Mobikode | Technology & Enterprise AI & ServiceNow Consulting Solutions"
                />

                <meta
                    name="twitter:description"
                    content="Talk to Mobikode's technology experts about your Enterprise AI & ServiceNow Consulting, software development, cloud, AI, ServiceNow, analytics, and enterprise technology requirements."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/contact/bg1.png"
                />
            </Helmet>

            <CHero />

            <ContactSection3 />
            <GlobalPresence />
            {/* <GeneralEnquiries /> */}

        </div>
    )
}

export default ContactDummy